import styled from 'styled-components';
import mixins from '../../../../styles/mixins';
import COLORS_MARKETPLACE from '../../../../constants/COLORS_MARKETPLACE';
import COLORS from '../../../../constants/COLORS';

export default {
  TypeFilter: styled.ul`
    ${mixins.listReset}
    ${mixins.hideScrollBar}
    display: flex;
    align-items: center;
    padding-top: 24px;
    overflow-x: auto;

    & > li {
      flex-shrink: 0;
      &:not(:last-child) {
        margin-right: 4px;
      }
    }
  `,

  TypeFilterBtn: styled.button<{ isActive?: boolean }>`
    ${mixins.btnReset}
    display: block;
    padding: 8px 12px;
    border: 1px solid ${COLORS.WHITE_F0};
    border-radius: 20px;
    font-size: 12px;
    line-height: 1.2;
    font-weight: ${({ isActive }) => (isActive ? '700' : '500')};
    background-color: ${({ isActive }) => (isActive ? COLORS_MARKETPLACE.GREY : 'transparent')};
    transition: 0.1s ease-in;
    &:hover,
    &:focus-visible {
      border-color: rgba(21, 16, 53, 0.4);
    }
  `,

  AnnouncementCount: styled.span`
    padding: 4px 10px;
    background: ${COLORS.GREY_DEE};
    border-radius: 16px;
    margin-left: 8px;
  `,
};
